var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoNissanFlat = function SvgLogoNissanFlat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 158.4 134.9",
    style: {
      enableBackground: "new 0 0 158.4 134.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C6C6C6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.1,55.6c-0.1-5-3.9-5.1-3.9-5.1c-2.3-0.4-4.6-0.7-6.9-1C139.1,21,111.7,0,79.2,0C47,0,19.8,20.6,11.3,48.8 c-1.9,0.4-3.6,0.7-5.4,1.1c-5,0.9-5.3,4.4-5.3,4.6c-1.1,4.5-0.5,19.6,0,24.7c0.3,5.4,4.8,5,5,5.1c1.6,0.4,3.5,0.7,5.5,1 c8.2,28.6,35.6,49.6,68.1,49.6c32.4,0,59.7-20.9,68-49.3c4.3-0.5,6.6-0.9,6.6-0.9c4-0.3,4.1-5.1,4.1-5.2 C158.7,72.6,158.2,55.6,158.1,55.6z M79.2,16.5c22.1,0,41,12.8,49.1,31c-38.8-3.3-79.8-1.9-97.8-0.9C38.9,28.8,57.6,16.5,79.2,16.5 z M114.8,74.8h-5.4l-1.6-3h-8.7l-1.4,3h-5.4l7.6-16.9h6.8L114.8,74.8z M78,68.5c0,0-3.3-0.3-3.8-4.4v-0.8c0,0-0.3-4.4,4.3-5.5h12.2 v4.4H79.6v2.5h9.2c0,0,3.3,1.1,3.3,4.4v0.8c0,0,0.3,3.5-3,4.9H74.5v-4.1h12.7v-2.2H78z M58.5,68.5c0,0-3.3-0.3-3.8-4.4v-0.8 c0,0-0.3-4.4,4.3-5.5h12.2v4.4H60.1v2.5h9.2c0,0,3.3,1.1,3.3,4.4v0.8c0,0,0.3,3.5-3,4.9H55v-4.1h12.7v-2.2H58.5z M51.4,57.9v16.9 h-6V57.9H51.4z M27.6,63.6v11.2h-5.1V57.9h8.7l6.2,12v-12h4.3v16.9h-7.9L27.6,63.6z M79.2,118.5c-22.1,0-41.1-12.8-49.2-31.1 c23.2,1.7,49.9,1.9,49.9,1.9c18.8,0.3,35.6-0.6,48.4-1.6C120.1,105.8,101.2,118.5,79.2,118.5z M135.9,74.8h-8.1l-6.5-11.5v11.5 h-5.1V57.9h8.9l5.7,11.7V57.9h5.1L135.9,74.8L135.9,74.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "103.4,62.5 101,67.4 105.9,67.4  "
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoNissanFlat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_nissan_flat.c47fe54d.svg";
export { ForwardRef as ReactComponent };